import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  TEAM_CALENDAR_GET_REQUEST,
  TEAM_CALENDAR_GET_SUCCESS,
  TEAM_CALENDAR_GET_FAILURE,
  TEAM_CALENDAR_SET_ITEMS,
  TEAM_CALENDAR_SET_MOMENT,
  TEAM_CALENDAR_SET_RANGE,
  TEAM_CALENDAR_SET_SEARCH,
  TEAM_CALENDAR_SET_TAB,
} from './../../constants'

export function getTeamCalendar(month, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/team-calendars?month=${month}`,
      method: 'GET',
      types: [
        TEAM_CALENDAR_GET_REQUEST,
        TEAM_CALENDAR_GET_SUCCESS,
        TEAM_CALENDAR_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function setOpenTeamCalendar(payload) {
  return {
    type: TEAM_CALENDAR_SET_ITEMS,
    payload,
  }
}

export function setMomentTeamCalendar(payload) {
  return {
    type: TEAM_CALENDAR_SET_MOMENT,
    payload,
  }
}

export function setRangeTeamCalendar(payload) {
  return {
    type: TEAM_CALENDAR_SET_RANGE,
    payload,
  }
}


export function setSearchTeamCalendar(payload) {
  return {
    type: TEAM_CALENDAR_SET_SEARCH,
    payload,
  }
}

export function setTabTeamCalendar(payload) {
  return {
    type: TEAM_CALENDAR_SET_TAB,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/actions/team-calendar/team-calendar-action.js